// extracted by mini-css-extract-plugin
module.exports = {"formattedContentBlock":"_1i1q2n8g"};